"use strict";Object.defineProperty(exports, "__esModule", {value: true});// src/command.ts
var _command = require('@ariakit/react-core/command/command');



exports.Command = _command.Command;
